import Vue from "vue";
import Router from "vue-router";
import App from "./views/App.vue";
import Auth from "./views/Auth.vue";
import ItemStream from "./components/app/ItemStream.vue";

Vue.use(Router);

const routes = [
  {
    path: "/",
    name: "app",
    component: App,
    redirect: `list-public-streams`,
    meta: { forAuth: true },
    children: [
      {
        path: `/list-public-streams`,
        name: `ListPublicStreams`,
        component: () => import("./components/app/ListPublicStreams.vue"),
        meta: { forAuth: true }
      },
      {
        path: `/list-my-streams`,
        name: `ListMyStreams`,
        component: () => import("./components/app/ListMyStreams.vue"),
        meta: { forAuth: true }
      },
      {
        path: `/item-public-stream/:id`,
        name: `ItemPublicStream`,
        component: ItemStream,
        meta: { forAuth: true }
      },
      {
        path: `/item-my-stream/:id`,
        name: `ItemMyStream`,
        component: ItemStream,
        meta: { forAuth: true }
      },
      {
        path: `/create-stream`,
        name: `CreateStream`,
        component: () => import("./components/app/CreateStream.vue"),
        meta: { forAuth: true }
      },
      {
        path: `/show-stream/:id`,
        name: `ShowStream`,
        component: () => import("./components/app/ShowStream.vue"),
        meta: { forAuth: true }
      },
      {
        path: `/shared-stream/:key`,
        name: `ShowSharedStream`,
        component: () => import("./components/app/ShowSharedStream.vue"),
        meta: { forAuth: true }
      },
      {
        path: `/finish-stream/:id`,
        name: `FinishStream`,
        component: () => import("./components/app/FinishStream.vue"),
        meta: { forAuth: true }
      },
      {
        path: `/edit-stream/:id`,
        name: `EditStream`,
        component: () => import("./components/app/EditStream.vue"),
        meta: { forAuth: true }
      },
      {
        path: `/profile`,
        name: `Profile`,
        component: () => import("./views/Profile.vue"),
        redirect: "menu-profile",
        // redirect: "edit-profile",
        meta: { forAuth: true },
        children: [
          {
            path: "/menu-profile",
            name: `MenuProfile`,
            component: () => import("./components/app/profile/MenuProfile.vue"),
            meta: { forAuth: true }
          },
          {
            path: "/edit-profile",
            name: `EditProfile`,
            component: () => import("./components/app/profile/EditProfile.vue"),
            meta: { forAuth: true }
          }
        ]
      }
    ]
  },
  {
    path: "/auth",
    name: "auth",
    component: Auth,
    redirect: `login`,
    meta: {
      forVisitors: true
    },
    children: [
      {
        path: `/login`,
        name: `Login`,
        component: () => import("./components/auth/Login.vue"),
        meta: {
          forVisitors: true
        }
      },
      {
        path: `/register`,
        name: `Register`,
        component: () => import("./components/auth/Register.vue"),
        meta: {
          forVisitors: true
        }
      }
    ]
  },
  {
    path: `/get-token`,
    name: `AuthRedirect`,
    component: () => import("./views/AuthRedirect.vue"),
    meta: {
      forVisitors: true
    }
  },
  {
    path: "/onboarding",
    name: "onboarding",
    component: () => import("./components/Onboarding.vue"),
    meta: { forAuth: true }
  },
  {
    path: `/alert`,
    name: `OpenInMobile`,
    component: () => import("./views/OpenInMobile.vue"),
    meta: {
      forVisitors: true
    }
  },
  {
    path: "*",
    name: "Page404",
    component: () => import("./views/404.vue")
  }
];

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior(to, from, savedPosition) {
    return savedPosition ? savedPosition : { x: 0, y: 0 };
  },
  routes: routes
  // {
  //   path: "/about",
  //   name: "about",
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () =>
  //     import(/* webpackChunkName: "about" */ "./views/About.vue")
  // }
});
